// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_profile-page__HD1ef {
  min-height: 100vh;
  background-size: cover;
  background-position: center center;
  padding-bottom: 120px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
}
.profile_profile-page__menu__gxxn8 {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 24px;
  padding: 40px 32px 32px 32px;
  min-width: 400px;
  max-width: 620px;
  color: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding-bottom: 100px;
}
.profile_profile-page__header__VoLFi {
  margin-bottom: 32px;
  text-align: left;
}
.profile_profile-page__title__eaZy2 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #3d3d3d;
}
.profile_profile-page__name__iE6fw {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 2px;
}
.profile_profile-page__email__\\+KHBx {
  font-size: 16px;
}
.profile_profile-page__nav__KfsAq {
  width: 100%;
}
.profile_profile-page__nav-item__qZEbp {
  margin-bottom: 12px;
}
.profile_profile-page__nav-link__qqfeb {
  color: #fff;
  font-size: 16px;
  padding: 12px 18px;
  border-radius: 16px;
  display: block;
  text-decoration: none;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: solid 1px #fff;
}
.profile_profile-page__nav-link__qqfeb:hover, .profile_profile-page__nav-link__qqfeb:focus, .profile_profile-page__nav-link--active__a3Kca {
  background: #fff;
  color: #000;
}
.profile_profile-page__content__8FtYZ {
  position: relative;
  border-radius: 7px;
  padding: 47px;
  flex: 1 1;
  min-width: 0;
  color: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.profile_profile-page__form__Nf3x0 {
  width: 100%;
}
.profile_profile-page__content-title__v\\+GwO {
  font-size: 1.7rem;
  font-weight: 700;
  margin-bottom: 18px;
  color: #fff;
}
.profile_profile-page__form-button__WaE44 {
  background: #27408D;
  color: #fff;
  border: none;
  border-radius: 17px;
  padding: 16px 25px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 24px;
  transition: all 0.2s;
  position: absolute;
  top: 30px;
  right: 30px;
  min-width: 190px;
}
.profile_profile-page__form-button__WaE44:hover, .profile_profile-page__form-button__WaE44:focus {
  background: #1d2e5b;
}
.profile_profile-page__form-content__rZGgH {
  margin-top: 50px;
}
.profile_profile-page__form-column__NaZHp {
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
}
.profile_profile-page__form-group-avatar__5\\+wg7 {
  display: flex;
  justify-content: center;
  align-items: start;
  height: 100%;
}
.profile_profile-page__form-avatar__li7uf {
  width: 100%;
  max-width: 420px;
  height: calc(100% - 12px);
  border-radius: 20px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #fff;
  cursor: pointer;
}
.profile_profile-page__avatar-img__7wfLi {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 24px;
}
.profile_profile-page__form-group__Ffpux {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
}
.profile_profile-page__form-label__PcITN {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.profile_profile-page__form-input__4EWGs {
  width: 100%;
  border: 1px solid #8b8b8b;
  background-color: transparent;
  border-radius: 10px;
  color: #1d1d1d;
  padding: 10px 44px 10px 16px;
  font-size: 1rem;
  outline: none;
  transition: border 0.2s;
}
.profile_profile-page__form-input__4EWGs::placeholder {
  color: #fff;
}
.profile_profile-page__form-input__4EWGs:focus {
  border: 1.5px solid #27408D;
  background: rgba(255, 255, 255, 0.18);
}
.profile_profile-page__form-input-icon__mMQ61 {
  position: absolute;
  right: 16px;
  color: #bfc6d1;
  font-size: 1.2rem;
  pointer-events: none;
}
.profile_profile-page__form-input-error__uT0P4 {
  color: #ff6b6b;
  font-size: 0.9rem;
  margin-top: 2px;
  min-height: 18px;
}
.profile_profile-page__form-submit__PymYn {
  background: #27408D;
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 10px 32px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 12px;
  transition: all 0.2s;
}
.profile_profile-page__form-submit__PymYn:hover, .profile_profile-page__form-submit__PymYn:focus {
  background: #1d2e5b;
}
.profile_profile-page__form-input__4EWGs {
  min-height: 60px;
  resize: vertical;
}
@media (max-width: 991px) {
  .profile_profile-page__menu__gxxn8, .profile_profile-page__content__8FtYZ {
    padding: 24px 12px 18px 12px;
    min-width: unset;
    max-width: unset;
  }
  .profile_profile-page__form-avatar__li7uf {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 767px) {
  .profile_profile-page__HD1ef {
    flex-direction: column;
    align-items: stretch;
    padding-top: 60px;
  }
  .profile_profile-page__menu__gxxn8, .profile_profile-page__content__8FtYZ {
    margin-bottom: 18px;
    border-radius: 16px;
  }
  .profile_profile-page__form-avatar__li7uf {
    width: 90px;
    height: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/profile.module.scss"],"names":[],"mappings":"AAYA;EACE,iBAAA;EACA,sBAAA;EACA,kCAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAXF;AAaE;EACE,8BAvBa;EAwBb,mBAlBQ;EAmBR,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAzBU;EA0BV,0CApBW;EAqBX,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,eAAA;AAfJ;AAkBE;EACE,WAAA;AAhBJ;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,WAlEU;EAmEV,eAAA;EACA,kBAAA;EACA,mBAjEQ;EAkER,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAlBJ;AAoBI;EAGE,gBAjFQ;EAkFR,WAAA;AApBN;AAwBE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAtBJ;AAyBE;EACE,WAAA;AAvBJ;AA0BE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WA7GU;AAqFd;AA2BE;EACE,mBAnHY;EAoHZ,WAlHU;EAmHV,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAzBJ;AA2BI;EAEE,mBAlIe;AAwGrB;AA8BE;EACE,gBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AA9BJ;AAiCE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,0CA3JY;EA4JZ,sBAAA;EACA,eAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAxKQ;AAwIZ;AAmCE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAjCJ;AAoCE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAlCJ;AAqCE;EACE,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAnCJ;AAqCI;EACE,WA1MQ;AAuKd;AAsCI;EACE,2BAAA;EACA,qCAAA;AApCN;AAwCE;EACE,kBAAA;EACA,WAAA;EACA,cArNS;EAsNT,iBAAA;EACA,oBAAA;AAtCJ;AAyCE;EACE,cA1NU;EA2NV,iBAAA;EACA,eAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,mBArOY;EAsOZ,WApOU;EAqOV,YAAA;EACA,mBAlOQ;EAmOR,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAxCJ;AA0CI;EAEE,mBAhPe;AAuMrB;AA6CE;EACE,gBAAA;EACA,gBAAA;AA3CJ;AA8CE;EAEE;IAEE,4BAAA;IACA,gBAAA;IACA,gBAAA;EA9CJ;EAiDE;IACE,YAAA;IACA,aAAA;EA/CJ;AACF;AAkDE;EA9PF;IA+PI,sBAAA;IACA,oBAAA;IACA,iBAAA;EA/CF;EAiDE;IAEE,mBAAA;IACA,mBA3QM;EA2NV;EAmDE;IACE,WAAA;IACA,YAAA;EAjDJ;AACF","sourcesContent":["$color-bg-panel: rgba(0, 0, 0, 0.8);\n$color-primary: #27408D;\n$color-primary-dark: #1d2e5b;\n$color-white: #fff;\n$color-gray: #bfc6d1;\n$color-error: #ff6b6b;\n$radius-lg: 24px;\n$radius-md: 16px;\n$radius-sm: 10px;\n$shadow-panel: 0 8px 32px rgba(0, 0, 0, 0.25);\n$shadow-avatar: 0 4px 16px rgba(0, 0, 0, 0.12);\n\n.profile-page {\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center center;\n  padding-bottom: 120px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: relative;\n\n  &__menu {\n    background: $color-bg-panel;\n    border-radius: $radius-lg;\n    padding: 40px 32px 32px 32px;\n    min-width: 400px;\n    max-width: 620px;\n    color: $color-white;\n    box-shadow: $shadow-panel;\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    padding-bottom: 100px;\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: left;\n  }\n\n  &__title {\n    font-size: 30px;\n    font-weight: 700;\n    margin-bottom: 8px;\n    color: #3d3d3d;\n  }\n\n  &__name {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 2px;\n  }\n\n  &__email {\n    font-size: 16px;\n  }\n\n  &__nav {\n    width: 100%;\n  }\n\n  &__nav-item {\n    margin-bottom: 12px;\n  }\n\n  &__nav-link {\n    color: $color-white;\n    font-size: 16px;\n    padding: 12px 18px;\n    border-radius: $radius-md;\n    display: block;\n    text-decoration: none;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: solid 1px #fff;\n\n    &:hover,\n    &:focus,\n    &--active {\n      background: $color-white;\n      color: #000;\n    }\n  }\n\n  &__content {\n    position: relative;\n    border-radius: 7px;\n    padding: 47px;\n    flex: 1 1;\n    min-width: 0;\n    color: #fff;\n    box-shadow: 0 8px 32px rgb(0 0 0 / 6%);\n    margin-bottom: 32px;\n    margin-left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  &__form {\n    width: 100%;\n  }\n\n  &__content-title {\n    font-size: 1.7rem;\n    font-weight: 700;\n    margin-bottom: 18px;\n    color: $color-white;\n  }\n\n  &__form-button {\n    background: $color-primary;\n    color: $color-white;\n    border: none;\n    border-radius: 17px;\n    padding: 16px 25px;\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 24px;\n    transition: all 0.2s;\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    min-width: 190px;\n\n    &:hover,\n    &:focus {\n      background: $color-primary-dark;\n    }\n  }\n\n  &__form-content {\n    margin-top: 50px;\n  }\n\n  &__form-column {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    height: 100%;\n  }\n\n  &__form-group-avatar {\n    display: flex;\n    justify-content: center;\n    align-items: start;\n    height: 100%;\n  }\n\n  &__form-avatar {\n    width: 100%;\n    max-width: 420px;\n    height: calc(100% - 12px);\n    border-radius: 20px;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    margin: 0 auto;\n    box-shadow: $shadow-avatar;\n    border: 1px solid $color-white;\n    cursor: pointer;\n  }\n\n  &__avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: $radius-lg;\n  }\n\n  &__form-group {\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    width: 100%;\n  }\n\n  &__form-label {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  &__form-input {\n    width: 100%;\n    border: 1px solid #8b8b8b;\n    background-color: transparent;\n    border-radius: 10px;\n    color: #1d1d1d;\n    padding: 10px 44px 10px 16px;\n    font-size: 1rem;\n    outline: none;\n    transition: border 0.2s;\n\n    &::placeholder {\n      color: $color-white;\n    }\n\n    &:focus {\n      border: 1.5px solid $color-primary;\n      background: rgba(255, 255, 255, 0.18);\n    }\n  }\n\n  &__form-input-icon {\n    position: absolute;\n    right: 16px;\n    color: $color-gray;\n    font-size: 1.2rem;\n    pointer-events: none;\n  }\n\n  &__form-input-error {\n    color: $color-error;\n    font-size: 0.9rem;\n    margin-top: 2px;\n    min-height: 18px;\n  }\n\n  &__form-submit {\n    background: $color-primary;\n    color: $color-white;\n    border: none;\n    border-radius: $radius-md;\n    padding: 10px 32px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-top: 12px;\n    transition: all 0.2s;\n\n    &:hover,\n    &:focus {\n      background: $color-primary-dark;\n    }\n  }\n\n  &__form-input {\n    min-height: 60px;\n    resize: vertical;\n  }\n\n  @media (max-width: 991px) {\n\n    &__menu,\n    &__content {\n      padding: 24px 12px 18px 12px;\n      min-width: unset;\n      max-width: unset;\n    }\n\n    &__form-avatar {\n      width: 120px;\n      height: 120px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: stretch;\n    padding-top: 60px;\n\n    &__menu,\n    &__content {\n      margin-bottom: 18px;\n      border-radius: $radius-md;\n    }\n\n    &__form-avatar {\n      width: 90px;\n      height: 90px;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-page": `profile_profile-page__HD1ef`,
	"profile-page__menu": `profile_profile-page__menu__gxxn8`,
	"profile-page__header": `profile_profile-page__header__VoLFi`,
	"profile-page__title": `profile_profile-page__title__eaZy2`,
	"profile-page__name": `profile_profile-page__name__iE6fw`,
	"profile-page__email": `profile_profile-page__email__+KHBx`,
	"profile-page__nav": `profile_profile-page__nav__KfsAq`,
	"profile-page__nav-item": `profile_profile-page__nav-item__qZEbp`,
	"profile-page__nav-link": `profile_profile-page__nav-link__qqfeb`,
	"profile-page__nav-link--active": `profile_profile-page__nav-link--active__a3Kca`,
	"profile-page__content": `profile_profile-page__content__8FtYZ`,
	"profile-page__form": `profile_profile-page__form__Nf3x0`,
	"profile-page__content-title": `profile_profile-page__content-title__v+GwO`,
	"profile-page__form-button": `profile_profile-page__form-button__WaE44`,
	"profile-page__form-content": `profile_profile-page__form-content__rZGgH`,
	"profile-page__form-column": `profile_profile-page__form-column__NaZHp`,
	"profile-page__form-group-avatar": `profile_profile-page__form-group-avatar__5+wg7`,
	"profile-page__form-avatar": `profile_profile-page__form-avatar__li7uf`,
	"profile-page__avatar-img": `profile_profile-page__avatar-img__7wfLi`,
	"profile-page__form-group": `profile_profile-page__form-group__Ffpux`,
	"profile-page__form-label": `profile_profile-page__form-label__PcITN`,
	"profile-page__form-input": `profile_profile-page__form-input__4EWGs`,
	"profile-page__form-input-icon": `profile_profile-page__form-input-icon__mMQ61`,
	"profile-page__form-input-error": `profile_profile-page__form-input-error__uT0P4`,
	"profile-page__form-submit": `profile_profile-page__form-submit__PymYn`
};
export default ___CSS_LOADER_EXPORT___;
